module.exports = __webpack_public_path__ + "static/media/binto.d41c9f24.png";